export default {
  isWhisperModal: false,
  isEmoticonModal: false,
  myChatList:[],
  chatNotification: true,
  systemMessage: true,
  whisperType: 'all',
  whisperTarget: '',
  unReadChatLength: 0,
}
